import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import ContactUsForm from 'components/clarebrand/ContactUsForm'

const Container = tw.div`relative`;

const Content = tw.div``;
const ContentStyled = styled(Content)(props => [
  tw` `,
  props.YSpacing ? tw`py-10 lg:py-12` : tw``
]);

const FormContainer = styled.div`
  ${tw`p-10 sm:p-12 md:p-16 bg-brand2 text-brand5 relative`}
  form {
    ${tw`mt-4`}
  }
  h2 {
    ${tw`text-3xl sm:text-4xl text-brand5 content-center font-bold`}
  }
  input,textarea {
    ${tw`w-full bg-transparent text-brand5 text-base font-medium tracking-wide border-0 border-b-2 border-brand4 py-2 text-brand5 focus:border-brand5 hover:border-brand5 focus:outline-none transition duration-200`};

    ::placeholder {
      ${tw`text-brand4`}
    }
  }
`;

const SimpleForm =  () => {
  return (
    <div id="nav-contact-us">
    <Container>
      <ContentStyled>
        <FormContainer>
          <div tw="mx-auto max-w-4xl">
            <h2>Contact Us</h2>
            <ContactUsForm />
          </div>
        </FormContainer>
      </ContentStyled>
    </Container>
    </div>
  );
};

export default SimpleForm;
